import { CUSTOMER_QUERY_IDS } from 'api/Queries'
import { MOCK_EXTERNAL_LINKS, MOCK_PAGES_CONFIG } from 'dummy/MockedData'

import { MOCK_ACCOUNT_DETAILS } from './MockAccountDetails'
import { MOCK_ACCOUNT_USERS } from './MockAccountUsers'
import { MOCK_BALANCE } from './MockBalance'
import { MOCK_CONSUMPTIONS } from './MockConsumptions'
import { MOCK_CONTACT_DETAILS } from './MockContactDetails'
import { MOCK_CONTRACT_DETAILS } from './MockContractDetails'
import { MOCK_CONTRACT_LIST } from './MockContractList'
import { MOCK_COSTS } from './MockCosts'
import { MOCK_DOCUMENTS } from './MockDocuments'
import {
  MOCK_ENTITY_SEARCH_GROUPED_CONTRACTS,
  MOCK_ENTITY_SEARCH_GROUPED_DOCUMENTS,
  MOCK_ENTITY_SEARCH_GROUPED_METERS,
  MOCK_ENTITY_SEARCH_GROUPED_OPPORTUNITIES,
  MOCK_ENTITY_SEARCH_GROUPED_ORDERS
} from './MockEntitySearchGrouped'
import {
  MOCK_METER_COUNTER_DETAIL,
  MOCK_METER_COUNTER_DETAILS
} from './MockMeterCounterDetails'
import { MOCK_METER_DETAILS } from './MockMeterDetails'
import { MOCK_METER_LIST } from './MockMeterList'
import { MOCK_METER_READINGS } from './MockMeterReadings'
import { MOCK_OPPORTUNITIES } from './MockOpportunities'
import { MOCK_OPPORTUNITY_DETAILS } from './MockOpportunityDetails'
import { MOCK_ORDER_DETAILS } from './MockOrderDetails'
import { MOCK_ORDERS } from './MockOrders'
import { MOCK_ORGANIZATION_SETTINGS } from './MockOrganizationSettings'
import { MOCK_PAYMENTS } from './MockPayments'
import { MOCK_PORTAL_CONFIG } from './MockPortalConfig'
import { MOCK_PORTAL_USER } from './MockPortalUser'
import { MOCK_PRICES } from './MockPrices'
import { MOCK_REQUESTS } from './MockRequests'
import { MOCK_SCHEMAS } from './MockSchemas'
import { MOCK_TICKET_DETAILS } from './MockTicketDetails'
import { MOCK_WIDGETS } from './MockWidgets'
import {
  MOCK_CONTRACTS_FOR_SEARCH,
  MOCK_FILES_FOR_SEARCH,
  MOCK_METERS_FOR_SEARCH,
  MOCK_OPPORTUNITIES_FOR_SEARCH,
  MOCK_ORDERS_FOR_SEARCH
} from './search-entities'

const DUMMY_MOCKS = {
  [CUSTOMER_QUERY_IDS.GET_CONTRACT_DETAILS]: MOCK_CONTRACT_DETAILS,
  [CUSTOMER_QUERY_IDS.GET_CONTRACTS]: MOCK_CONTRACT_LIST,
  [CUSTOMER_QUERY_IDS.GET_METER_DETAILS]: MOCK_METER_DETAILS,
  [CUSTOMER_QUERY_IDS.GET_METERS]: MOCK_METER_LIST,
  [CUSTOMER_QUERY_IDS.GET_ORGANIZATION_SETTINGS]: MOCK_ORGANIZATION_SETTINGS,
  [CUSTOMER_QUERY_IDS.GET_METER_COUNTERS]: MOCK_METER_COUNTER_DETAILS,
  [CUSTOMER_QUERY_IDS.GET_COUNTER_DETAILS]: MOCK_METER_COUNTER_DETAIL,
  [CUSTOMER_QUERY_IDS.GET_READINGS_BY_INTERVAL]: MOCK_METER_READINGS,
  [CUSTOMER_QUERY_IDS.GET_BILLING_EVENTS]: MOCK_PAYMENTS,
  [CUSTOMER_QUERY_IDS.GET_BALANCE]: MOCK_BALANCE,
  [CUSTOMER_QUERY_IDS.GET_ACCOUNT_USERS]: MOCK_ACCOUNT_USERS,
  [CUSTOMER_QUERY_IDS.GET_PUBLIC_EXTENSIONS]: [],
  [CUSTOMER_QUERY_IDS.GET_ORDER_DETAILS]: MOCK_ORDER_DETAILS,
  [CUSTOMER_QUERY_IDS.GET_OPPORTUNITY_DETAILS]: MOCK_OPPORTUNITY_DETAILS,
  [CUSTOMER_QUERY_IDS.GET_ALL_ORDERS]: MOCK_ORDERS,
  [CUSTOMER_QUERY_IDS.GET_ALL_OPPORTUNITIES]: MOCK_OPPORTUNITIES,
  [CUSTOMER_QUERY_IDS.GET_CONTACT]: MOCK_CONTACT_DETAILS,
  [CUSTOMER_QUERY_IDS.PORTAL_USER]: MOCK_PORTAL_USER,
  [CUSTOMER_QUERY_IDS.GET_SCHEMAS]: MOCK_SCHEMAS,
  [CUSTOMER_QUERY_IDS.GET_PORTAL_CONFIG]: MOCK_PORTAL_CONFIG,
  [CUSTOMER_QUERY_IDS.GET_PORTAL_WIDGETS]: MOCK_WIDGETS,
  [CUSTOMER_QUERY_IDS.GET_CONSUMPTIONS]: MOCK_CONSUMPTIONS,
  [CUSTOMER_QUERY_IDS.GET_COSTS]: MOCK_COSTS,
  [CUSTOMER_QUERY_IDS.GET_PRICES]: MOCK_PRICES,
  [CUSTOMER_QUERY_IDS.GET_DOCUMENTS]: MOCK_DOCUMENTS,
  [CUSTOMER_QUERY_IDS.GET_PAGES]: MOCK_PAGES_CONFIG,
  [CUSTOMER_QUERY_IDS.GET_ALL_REQUESTS]: MOCK_REQUESTS,
  [CUSTOMER_QUERY_IDS.GET_EXTERNAL_LINKS]: MOCK_EXTERNAL_LINKS,
  [`${CUSTOMER_QUERY_IDS.GET_ENTITY}_contract`]: {
    result: MOCK_CONTRACT_DETAILS.entity
  },
  [`${CUSTOMER_QUERY_IDS.GET_ENTITY}_meter`]: {
    result: MOCK_METER_DETAILS.entity
  },
  [`${CUSTOMER_QUERY_IDS.GET_ENTITY}_opportunity`]: {
    result: MOCK_OPPORTUNITY_DETAILS.entity
  },
  [`${CUSTOMER_QUERY_IDS.GET_ENTITY}_order`]: {
    result: MOCK_ORDER_DETAILS.entity
  },

  [`${CUSTOMER_QUERY_IDS.SEARCH_ENTITIES}_contract`]: {
    results: MOCK_CONTRACTS_FOR_SEARCH
  },
  [`${CUSTOMER_QUERY_IDS.SEARCH_ENTITIES}_file`]: {
    results: MOCK_FILES_FOR_SEARCH
  },
  [`${CUSTOMER_QUERY_IDS.SEARCH_ENTITIES}_meter`]: {
    results: MOCK_METERS_FOR_SEARCH
  },
  [`${CUSTOMER_QUERY_IDS.SEARCH_ENTITIES}_opportunity`]: {
    results: MOCK_OPPORTUNITIES_FOR_SEARCH
  },
  [`${CUSTOMER_QUERY_IDS.SEARCH_ENTITIES}_order`]: {
    results: MOCK_ORDERS_FOR_SEARCH
  },
  [`${CUSTOMER_QUERY_IDS.SEARCH_ENTITIES}_opportunity,order`]: {
    results: [
      ...MOCK_OPPORTUNITIES_FOR_SEARCH.slice(0, 3),
      ...MOCK_ORDERS_FOR_SEARCH.slice(0, 3)
    ]
  },

  [`${CUSTOMER_QUERY_IDS.SEARCH_ENTITIES}_GROUPED_contract`]:
    MOCK_ENTITY_SEARCH_GROUPED_CONTRACTS,
  [`${CUSTOMER_QUERY_IDS.SEARCH_ENTITIES}_GROUPED_file`]:
    MOCK_ENTITY_SEARCH_GROUPED_DOCUMENTS,
  [`${CUSTOMER_QUERY_IDS.SEARCH_ENTITIES}_GROUPED_order`]:
    MOCK_ENTITY_SEARCH_GROUPED_ORDERS,
  [`${CUSTOMER_QUERY_IDS.SEARCH_ENTITIES}_GROUPED_meter`]:
    MOCK_ENTITY_SEARCH_GROUPED_METERS,
  [`${CUSTOMER_QUERY_IDS.SEARCH_ENTITIES}_GROUPED_opportunity`]:
    MOCK_ENTITY_SEARCH_GROUPED_OPPORTUNITIES,
  [`${CUSTOMER_QUERY_IDS.SEARCH_ENTITIES}_GROUPED_opportunity,order`]: {
    groups: [
      ...MOCK_ENTITY_SEARCH_GROUPED_OPPORTUNITIES.groups.slice(0, 3),
      ...MOCK_ENTITY_SEARCH_GROUPED_ORDERS.groups.slice(0, 3)
    ]
  },
  [`${CUSTOMER_QUERY_IDS.GET_PAGE_ENTITY}`]: {
    entities: {
      contract: {
        ...MOCK_CONTRACT_DETAILS.entity,
        workflow: MOCK_CONTRACT_DETAILS.workflow,
        meters: [MOCK_METER_DETAILS.entity]
      },
      meter: {
        ...MOCK_METER_DETAILS.entity,
        contract: [MOCK_CONTRACT_DETAILS.entity]
      },
      opportunity: {
        ...MOCK_OPPORTUNITY_DETAILS.entity,
        workflow: MOCK_OPPORTUNITY_DETAILS.workflow
      },
      order: {
        ...MOCK_ORDER_DETAILS.entity,
        workflow: MOCK_ORDER_DETAILS.workflow
      },
      contact: {
        ...MOCK_CONTACT_DETAILS.entity,
        workflow: MOCK_ORDER_DETAILS.workflow
      },
      account: MOCK_ACCOUNT_DETAILS.entity,
      ticket: MOCK_TICKET_DETAILS.entity
    },
    templates_output: {
      contract: {
        _id: '123',
        _schema: 'contract',
        _title: 'Contract 1'
      }
    }
  }
}

export default DUMMY_MOCKS
